import { HttpStatusCode } from 'axios';
import { GuestSmartAssistantService } from 'services/guest-smart-assistant-service';
import { AUTHENTICATED_GUEST_SMART_ASSISTANT_ID } from 'shared/constants/guest-smart-assistant';
import { axiosGuestSmartAssistantInstance } from 'shared/utils/axios-instances';

export const initGuestSmartAssistantInterceptor = () => {
  axiosGuestSmartAssistantInstance.interceptors.request.use(
    (config) => {
      const guestSmartAssistantId = sessionStorage.getItem(AUTHENTICATED_GUEST_SMART_ASSISTANT_ID);
      if (guestSmartAssistantId && GuestSmartAssistantService.isAuthenticated(guestSmartAssistantId)) {
        config.headers.Authorization = `Bearer ${GuestSmartAssistantService.getAccessToken(guestSmartAssistantId)}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  axiosGuestSmartAssistantInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      const originalRequest = error.config;
      if (error.response.status === HttpStatusCode.Unauthorized && !originalRequest.sent) {
        // Prevent infinite loops by setting sent to true
        originalRequest.sent = true;

        const guestSmartAssistantId = sessionStorage.getItem(AUTHENTICATED_GUEST_SMART_ASSISTANT_ID);
        if (guestSmartAssistantId) {
          GuestSmartAssistantService.refreshAccessToken(guestSmartAssistantId)
            .then(() => {
              axiosGuestSmartAssistantInstance(originalRequest);
            })
            .catch(() => {
              GuestSmartAssistantService.clearSession(guestSmartAssistantId);
            });
        }
      }

      return Promise.reject(error);
    }
  );
};
